import styled from "styled-components";

const TeamMemberStyleWrapper = styled.article`
  .hermes_team_card {
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    max-width: 100%;
    height: 300px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .team_member_img {
      border-radius: 50px;
      overflow: hidden;
    }
    h3 {
      color: #ffffff;
      font-size: 24px;
      line-height: 34px;
      text-align: center;
      margin-top: 28px;
      margin-bottom: 4px;
    }
    h4 {
      font-family: "Inter";
      font-style: normal;
      text-align: center;
      font-size: 16px;
      line-height: 19px;
      color: rgba(255, 255, 255, 0.8);
      margin: 0;
    }
  }

  .member_name,
  .member_designation {
    position: relative;
  }

  .member_name::before {
    position: absolute;
    font-size: 24px;
    margin-top: 27px;
    font-family: "Bakbak One", cursive;
    letter-spacing: 0px;
    word-spacing: 0px;
  }
  .member_designation::before {
    position: absolute;
    font-size: 16px;
    font-family: "Inter";
    letter-spacing: 0px;
    word-spacing: 0px;
    text-wrap: nowrap;
    margin-top: -2px;
  }

  .team_social_icon {
    width: 100%;
    position: absolute;
    bottom: -20px;
    display: flex;
    align-items: center;
    justify-content: center;
    ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 220px;
      width: 100%;
      margin: 0;
      padding: 0;
      li {
        height: 50px;
        width: 50px;
        background: #0f181d;
        border: 2px solid var(--primary-color);
        opacity: 0;
        transition: 0.4s;
        a {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          width: 100%;
          color: #ffffff;
          svg {
            stroke: var(--primary-color);
            stroke-width: 30px;
            stroke-linejoin: round;
            stroke-linecap: round;
            width: 22px;
            height: 22px;
          }
        }
      }
    }
  }

  &:hover {
    border: 2px solid var(--primary-color);
    &:hover {
      .team_social_icon {
        ul {
          li {
            opacity: 1;
          }
        }
      }
      .member_name::before,
      .member_designation::before {
        content: attr(data-text);
        position: absolute;
        display: flex;
        align-item: center;
        justify-content: center;
        -webkit-text-stroke: 6px var(--primary-color);
        color: var(--primary-color);
        z-index: -1;
      }
      .member_designation::before {
        -webkit-text-stroke: 4px var(--primary-color);
      }
    }
  }

  @media only screen and (max-width: 991px) {
    .hermes_team_card {
      h3 {
        font-size: 18px;
        line-height: 28px;
      }
      .member_name::before {
        font-size: 18px;
      }
    }
  }
`;

export default TeamMemberStyleWrapper;
